<div>
    <ngx-create-state-customer [id]="CustStId"></ngx-create-state-customer>
</div>